import React from 'react';
import SecondaryButtonThemeProvider from 'src/components/ThemeProvider/SecondaryButtonThemeProvider';
import * as V from '@veneer/core';

type ButtonWithSecondaryThemeProviderProps = {
  children: React.ReactNode;
  enableTheme?: boolean;
  [key: string]: unknown;
};

export const ButtonWithSecondaryThemeProvider = ({
  children,
  enableTheme,
  ...props
}: ButtonWithSecondaryThemeProviderProps): JSX.Element => {
  return (
    <SecondaryButtonThemeProvider enableTheme={enableTheme}>
      <V.Button {...props}>{children}</V.Button>
    </SecondaryButtonThemeProvider>
  );
};
